import { useState } from "react";

const CheckboxLabel = (props: any) => {
  let title = props.title ?? "";
  let value = props.value ?? false;
  const [status, setStatus] = useState(value);
  const toggleClick = () => {
    if (status) {
      setStatus(0);
    }
    else {
      setStatus(1);
    }
    props.toggleClick(status);
  }
  return (
    <div className="CheckBoxLable row m-0">
      <div className={`Marker   ${status ? "Active" : ""}`} onClick={toggleClick}>
      </div>
      <p className="p-1 ">{title}</p>
    </div>
  )
}

export default CheckboxLabel